"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageType = void 0;
var LanguageType;
(function (LanguageType) {
    LanguageType["ASLSignLanguage"] = "ASL_SIGN_LANGUAGE";
    LanguageType["Chinese"] = "CHINESE";
    LanguageType["English"] = "ENGLISH";
    LanguageType["French"] = "FRENCH";
    LanguageType["Latin"] = "LATIN";
    LanguageType["Spanish"] = "SPANISH";
})(LanguageType = exports.LanguageType || (exports.LanguageType = {}));
